Vue.component('share-doc', {
	props: ['options', 'labellang'],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<div id="share-doc">' +
		'<form id="fileChooserForm">' +
		'<div class="overlay-content">' +
		'<button type="button" @click="closeView" class="close" aria-label="Close">' +
		'<span aria-hidden="true">&times;</span>' +
		'</button>' +
		'<h3>{{ this.title }}</h3>' +
		'<label class="offset-top-20" for="file" >{{ noFileSelected()  }}</label>' +
		'<input type="file" id="fileChooser" @change="onChangeInput"  name="file" >' +
		'<p class="offset-top-20" :class="{ \'error-msg\': textError }">{{ this.messageUpload }}</p>' +
		'</div>' +
		'<div class="overlay-footer">' +
		'<button @click.prevent="closeView" class="btn pull-left"  >{{ this.labellang.cancel }}</button>' +
		'<button @click.prevent="sendFile" class="btn btn-info pull-right" :disabled="isSendDisable">{{ this.labellang.send }}</button>' +
		'</div>' +
		'</form>' +
		'</div>' +
		'</transition>',

	data: function () {
		return {
			title: this.labellang.selectFile,
			isActive: false,
			uploadError: null,
			messageUpload: '',
			isSendDisable: true,
			textError: false

		}
	},
	mounted: function () {
		var that = this;
		bus.$on('onShareDoc', function (val) {
			that.contentShow(val);
		})

		this.$parent.$on('onShareDoc', function (val) {
			that.contentShow(val);
		})

		this.$parent.$on('onMaxSizeFile', function () {
			that.maxFileSize();
		})

	},
	methods: {
		contentShow: function (val) {
			this.isActive = val;
		},
		noFileSelected: function () {
			return this.labellang.noFileSelected
		},
		closeView: function () {
			this.isActive = false;
			this.messageUpload = "";
		},
		sendFile: function () {
			this.options.internal.bridge.sendFile('fileChooser');
			this.messageUpload = '';
			this.isActive = false;
			this.isSendDisable = true;
			setTimeout(function () {
				bus.$emit('onUpdateScroll');
				bus.$emit('showBackButton', false);
			}, 300);

		},
		maxFileSize: function () {
			this.messageUpload = this.labellang.documentSizeExceeded;
			this.isSendDisable = false;
		},
		validateFile: function (fileExt) {
			var fileTypes = this.options.internal.notAllowedExtensions;
			for (var i = 0; i < fileTypes.length; i++) {
				if (fileExt === fileTypes[i]) {
					return false;
				}
			}
			//se non è ne nelle unsupported extension controllo se ci sono delle supported extension da controllare
			if(this.options.internal.allowedExtensions){
				if(this.options.internal.allowedExtensions.indexOf(fileExt) >= 0){
					return true;
				}else{
					return false;
				}
			}
			return true;
		},
		returnFileSize: function (number) {
			if (number < 1024) {
				return number + 'bytes';
			} else if (number > 1024 && number < 1048576) {
				return (number / 1024).toFixed(1) + 'KB';
			} else if (number > 1048576) {
				return (number / 1048576).toFixed(1) + 'MB';
			}
		},
		onChangeInput: function (e) {
			var files = e.target.files || e.dataTransfer.files;

			if (!files.length) {
				return;
			}
			var haveExt = files[0].name.split('.');

			if (haveExt.length <= 1) {
				this.isSendDisable = true;
				this.messageUpload = this.labellang.no_extension;
				this.textError = true;
				return;
			}


			for (var i = 0; i < files.length; i++) {
				var ext = files[i].name.split('.').pop().toLowerCase();

				if (files[i].size > 0) {
					if (this.validateFile(ext)) {
						this.isSendDisable = false;
						var textContent = 'File name ' + files[i].name + ', file size ' + this.returnFileSize(files[i].size) + '.';
						this.messageUpload = textContent;
						this.textError = false
					} else {
						this.messageUpload = this.labellang.extensionError;
						this.textError = true

					}
				} else {
					this.isSendDisable = true;
					this.messageUpload = this.labellang.emptyFile;
					this.textError = true;

				}


			}
		},
	},
})
